import { UserRepository } from '@domain/repositories/UserRepository'
import { Http } from './Http'
import { userRepository } from '@microservices/repositories/UserRepository'
import { API_URL } from '@assets/constants'

const http = new Http(API_URL)
export const userRepo: UserRepository = userRepository(http)
